import { coreClient } from '@/api/coreclient'

export default {
  async create(groupId: number, userIds: string[]) {
    const client = await coreClient()
    return client.groupUser
      .create(groupId, { user_ids: userIds })
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async delete(groupId: number, userId: string) {
    const client = await coreClient()
    return client.groupUser
      .delete(groupId, userId)
      .then(() => {
        return true
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
